import { getCurrentInstance } from 'vue'

/*
* Analytics is a plugin and by providing it from the root instance, we can make it available for the composition API.
*/
export default function useAnalytics() {
  const instance = getCurrentInstance()
  const trackMixpanelEvent = instance?.appContext.config.globalProperties.$trackMixpanelEvent
  const trackEvent = instance?.appContext.config.globalProperties.$trackEvent

  return {
    /**
    * @deprecated Please use trackMixpanelEvent instead.
    */
    trackEvent,
    trackMixpanelEvent
  }
}
